import { StaticImageData } from 'next/image';
import tShirt from '../../../public/webp/fromPNG/tShirt.webp';
import type { IData } from './ChatUseCases.types';
export const data: IData = {
  headline: {
    title: 'Some of the AI chat assistant use cases',
    description: `AI chatbots can bring value to a wide range of industries by
        enhancing customer interactions, streamlining processes, and
        improving overall efficiency.
        <br /> Here are some industries that could benefit significantly
        from implementing AI chatbots:`,
  },
  chatsSections: [
    {
      infoSections: [
        {
          title: 'AI chatbots in fintech',
          description:
            'AI chatbots can help with account inquiries, transaction history, and provide product recommendations. They can also enhance security measures through multi-factor authentication.',
        },
        {
          title: 'AI chatbots in healthtech',
          description:
            'Conversational AI chatbots can be used for appointment scheduling, medication reminders, and providing basic health information, contributing to improved patient engagement and healthcare accessibility. Medical personnel can also use the chat to streamline their work - access patient info, collect suggestions regarding their patients, set reminders - it all contributes to a significant efficiency boost.',
        },
      ],

      chatBoxProps: {
        useFingerPrint: true,
        messages: [
          {
            key: 1,
            delay: 2000,
            showTime: true,
            time: '8:20 PM',
            text: "Hey, what's my savings balance?",
            writerId: 2,
          },
          {
            key: 2,
            delay: 2000,
            showTime: true,
            time: '8:20 PM',
            text: 'Your savings balance is $9.247,98.',
            writerId: 1,
          },
          {
            key: 3,
            delay: 5000,
            showTime: true,
            time: '8:21 PM',
            text: 'OK.Send $350 from savings to Mark.',
            writerId: 2,
          },
          {
            key: 4,
            delay: 2000,
            showTime: true,
            time: '8:21 PM',
            text: 'Send $350.00 from Savings Account to Mark? Confirm the operation by fingerprint',
            writerId: 1,
          },
        ],
      },
    },
    {
      infoSections: [
        {
          title: 'AI chatbots in e-commerce',
          description:
            'AI chatbots can assist customers in finding products, provide recommendations based on preferences, and facilitate the purchasing process, enhancing the overall shopping experience.',
        },
        {
          title: 'AI chatbots in human resources',
          description:
            'AI assistants in HR can streamline the recruitment process, assist employees with HR-related queries, and provide information about company policies and benefits. AI chatbots are also a great potential replacement for intranets.',
        },
      ],

      chatBoxProps: {
        useFingerPrint: false,
        messages: [
          {
            key: 1,
            delay: 2000,
            showTime: true,
            time: '11:14 AM',
            text: "One of the items in your cart just went out of stock. Do you want me to send you a notification once it's back?",
            writerId: 1,
            pic: {
              img: (tShirt as unknown as StaticImageData).src,
              desc: 'White T-shirt <br/> Size: L',
            },
          },
          {
            key: 2,
            delay: 4000,
            showTime: true,
            time: '11:14 AM',
            text: 'Yes, let me know.',
            writerId: 2,
          },
          {
            key: 3,
            delay: 2500,
            showTime: true,
            time: '11:14 AM',
            text: 'OK, do you want to see similar products?',
            writerId: 1,
          },
        ],
      },
    },
  ],
  otherInfoRows: [
    {
      infoSections: [
        {
          title: 'AI chatbots in insurance',
          description:
            'AI-powered chatbots can help users understand insurance policies, assist in filing claims, and provide information about coverage and premiums.',
        },
        {
          title: 'AI chatbots in legal',
          description:
            'AI chatbots can provide legal information on very complex legal matters within a specific context, assist in document preparation, and guide users through legal processes. On the other hand, a law firm can use the AI assistant to swiftly access case documents, search for relevant info in their internal databases, and streamline the process of creating new legal documents. ',
        },
      ],
    },
    {
      infoSections: [
        {
          title: 'AI chatbots in education',
          description:
            'AI-based chatbots can be used to provide learning support, answer student queries, and offer personalized learning experiences. They can be a great tool for learning new skills and languages.',
        },
        {
          title: 'AI chatbot in your company',
          description:
            'We bet your digital business could benefit from implementing an AI chatbot, too! Our AI experts are here to discuss your specific case and guide you through the entire process of AI assistant development. ',
        },
      ],
    },
  ],
};
